<template>
    <div
        :class="{ 'large-text': largeText }"
        class="cz2__pet-pack-add-remove-button"
    >
        <btn
            v-if="!petPackInCart"
            @click="addPetPack"
            primary
            class="cz2__full-width"
        >
            {{ addButtonCopy }}
        </btn>

        <btn
            v-else
            gray
            @click="removePetPack"
            class="cz2__full-width"
        >
            <img
                v-if="showIcon"
                src="../assets/icons/trash-icon.svg"
                width="20"
                height="20"
                aria-hidden="true"
                :class="{ 'hide-on-xs': hideIconMobile }"
            />
            {{ $t('PET_PACK_CTA_REMOVE') }}
        </btn>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";
    @import "../style/shared.scss";

    #cz2.cz2 {
        .cz2__pet-pack-add-remove-button {
            .cz2__btn {
                width: 100%;
                display: flex;
                gap: 10px;
                padding-left: 16px;
                padding-right: 16px;
            }

            &:hover {
                font-size: 16px;
            }

            &.large-text {
                .cz2__btn {
                    font-size: 22px;
                }
            }

            @media (max-width: 460px) {
                .hide-on-xs {
                    display: none;
                }
            }
        }
    }
</style>

<script>
    import Btn from './ui/Btn.vue';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        components: {
            Btn,
        },

        props: {
            largeText: {
                type: Boolean,
                default: false,
            },

            showPrice: {
                type: Boolean,
                default: true,
            },

            showIcon: {
                type: Boolean,
                default: true,
            },

            hideIconMobile: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            petPackInCart() {
                return this.$store.getters.petPackInCart;
            },

            availableBuddyPack() {
                return this.$store.getters.availableBuddyPack;
            },

            viewController() {
                return this.$store.state.customizer.viewController;
            },

            price() {
                if (this.availableBuddyPack) {
                    const price = this.viewController.getPrice(this.availableBuddyPack);

                    return formatPrice(this.$store.state, price, 'noDigits');
                }

                return '';
            },

            addButtonCopy() {
                const price = this.showPrice ? ` + ${this.price}` : '';
                const ctaCopy = this.isMobile ? this.$t('PET_PACK_CTA_ADD_MOBILE') : this.$t('PET_PACK_CTA_ADD');

                return `${ctaCopy}${price}`;
            },

            petPackInfoModalShown() {
                return this.$store.state.petPackInfoModalShown;
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },
        },

        methods: {
            addPetPack() {
                const pack = this.viewController.findPlacement('POPBuddyPack');

                if (pack) {
                    const toSelect = pack.components.find((x) => !x.placeholder && this.viewController.isAvailable(x));

                    if (toSelect) {
                        this.viewController.updateComponent(pack.code, toSelect.code);
                    }
                }

                this.closeInfoModal();
            },

            removePetPack() {
                const pack = this.viewController.findPlacement('POPBuddyPack');

                if (pack) {
                    const toSelect = pack.components.find((x) => x.placeholder);

                    if (toSelect) {
                        this.viewController.updateComponent(pack.code, toSelect.code);
                    }
                }

                this.closeInfoModal();
            },

            closeInfoModal() {
                if (this.petPackInfoModalShown) {
                    this.$store.dispatch('showPetPackInfoModal', false);
                }
            },
        },
    };
</script>
